import { render } from "./SearcherPage.vue?vue&type=template&id=8a0b79be"
import script from "./SearcherPage.vue?vue&type=script&lang=js"
export * from "./SearcherPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__